<template>
	<div class="appheader-wrap">
		<div class="appheader" id="nav" :class="{'hiddenBg':$route.name=='home'}">
			<div class="w">

				<div class="logo" @click="$router.push('/')">
					 <img :src="contact.logo"  width="170" />
				</div>
				<div class="user-info">

					<el-dropdown>
					    <span class="el-dropdown-link" style=" cursor: pointer;">

						     <span @click="$router.push('/we')" v-if="token">
						     	Hello！ 
						         {{userInfo.nickname}}
						     </span>

						    <span @click="$router.push('/login')" v-else>
						    	 Sign In 
						    </span>

					    </span>
					    <el-dropdown-menu slot="dropdown" class="pc-element">
						    <el-dropdown-item>
						    	<li @click="$router.push('/order')">
									Order
								</li>
							</el-dropdown-item>
						    <el-dropdown-item>
						    	<li @click="$router.push('/modifyInfo')">
									My Account
								</li>
							</el-dropdown-item>
						    <el-dropdown-item >
						    	<li @click="$router.push('/receivelist')">
									Address
								</li>
							</el-dropdown-item>
						    <el-dropdown-item divided>
						    	<li @click="logout">
									Sign Out
								</li>
							</el-dropdown-item>
					    </el-dropdown-menu>
					</el-dropdown>


					<div class="help-wrap">
						<img src="../assets/car.png" width="24" @click="gotopay">
					</div>

					<el-dropdown class="pc-element help-wrap">
					  <span class="el-dropdown-link" style=" cursor: pointer;">
					        Help
					  </span>
					  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item>
						    	<li @click="$router.push('/shipping')">Shipping and Delivery</li>
							</el-dropdown-item>
						    <el-dropdown-item>
						    	<li @click="$router.push('/returns')">Warranty and Returns</li>
							</el-dropdown-item>
						    <el-dropdown-item >
						    	<li @click="$router.push('/contact')">Contact Us</li>
							</el-dropdown-item>
					  </el-dropdown-menu>
					</el-dropdown>


                     
                    <div class="help-wrap web-element">
						<img src="../assets/ham.png" width="24" @click="showPopup">
						<van-popup v-model="show" position="right" :style="{ width: '50%',height:'100%' }">
							 <div class="web-nav">
							 	 <h6>User</h6>
							 	 <ul>
							 	 	<li @click="$router.push('/order')">
										Order
									</li>
									<li @click="$router.push('/modifyInfo')">
										My Account
									</li>
									<li @click="$router.push('/receivelist')">
										Address
									</li>
									<li @click="logout">
										Sign Out
									</li>
							 	 </ul>
							 	 <h6>Help</h6>
							 	 <ul>
							 	 	 <li @click="$router.push('/shipping')">Shipping and delivery</li>
							 	 	 <li @click="$router.push('/returns')">Warranty and Returns</li>
							 	 	 <li @click="$router.push('/contact')">Contact Us</li>
							 	 </ul>
							 </div>
						</van-popup>
					</div>

				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
   import {mapState} from 'vuex'
   import { Popup } from 'vant';

	export default {
		data () {
			return {
				hasLogin:true,
				show:false,
			}
		},
		watch: { //监听路由变化
			$route(to, from) {
               this.show = false;
			}
		},
		computed: {
			 ...mapState({
			 	  token:state => state.token,
                  userInfo: state => state.userInfo,
                  contact: state => state.contact,
                  
            }),
		},
		mounted() {
            
        },
		methods: {
			showPopup(){
                this.show = true;
			},
			gotopay(){
				this.$router.push("/order?status=1")
			},
			logout(){
				 this.$store.dispatch('SET_USER', {nickname:""});
				 this.$store.dispatch('SET_TOKEN',"");
				 this.$api2.setGhStorageItem("url","");
                 this.$router.push("/login");
			}
		}
	}
</script>

<style lang="less" >
    .web-nav{
    	padding-top:50px;
    	line-height:3;
    	h6{
    	   font-size:16px;
    	   padding-left:10px;
    	   padding-right:20px;
    	}
    	li{
    	   padding-left:20px;
    	   font-size:14px;
    	   border-bottom:1px solid #eee;
    	}
    }
    .appheader-wrap{
		height: 96px;
		top: 0;
		width: 100%;
		left: 0;
		z-index: 999;
		position: fixed;
	    .appheader{
			height: 100%;
			box-sizing:border-box;
			background-color:transparent;
			background-color:#fff;
			border-bottom:1px solid #dcdddd;
			&.hiddenBg{
				background-color:transparent;
				border-bottom:0;
			}
			.w{
				width: 80%;
				height: 100%;
				margin: 0 auto;
				display: flex;
				justify-content: space-between;
				align-items: center;
				.logo{
					cursor: pointer;
				}
				.user-info{
                    display:flex;
                    align-items:center;
					.help-wrap{
						cursor: pointer;
						margin-left:18px;
						position:relative;
						
					}
					.user-info-login{
						.bind{
							display:inline-block;
							background:#90c31f;
							padding:0 40px;
							line-height:40px;
							color:#ffffff;
							font-size:16px;
							border-radius:20px;
							margin-right:40px;
							vertical-align: middle;
						}
						span{
	                        font-size:16px;
	                        color:#333333;
	                        cursor:pointer;
						}
					}
	                button{
	                	color:#333333;
						font-size: 16px;
						&.logout{
					    	color: #999;
					    	font-size:14px;
					    	&:hover{
					    		color:red
					    	}
					    }
						i{
							margin-right: 4px;
						}
	                }
				}
			}
		}

    }




	@media screen and (max-width:768px) {
		.appheader-wrap{
	    	height:50px;
			.appheader {
				height: 50px;
				border-bottom: none;
				box-shadow:0 0 2px 0 rgba(0,0,0,.2);
				.w {
					width:100%;
					padding:0 4%;
					box-sizing:border-box;
					.user-info{
						.user-info-login {
							.bind{
	                             line-height: 20px;
	                             margin-right:4px;
	                             padding:0 10px;
	                             font-size:10px;
							}
							span{
								font-size:12px;
							}
					    }
						button.logout{
							font-size:12px;
						}
					}
					.logo{
	                     img{
	                     	width:100px;
	                     }
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/header.vue